var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductHostingShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEA\xB2\xA9\xEB\xA6\xAC_\xEB\xAA\xA8\xEB\x93\x9C",
    clipPath: "url(#clip0_2881_52824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.048 41.9999C32.6186 41.9999 41.9984 32.5979 41.9984 20.9999C41.9984 9.402 32.6186 0 21.048 0C9.47745 0 0.0976562 9.402 0.0976562 20.9999C0.0976562 32.5979 9.47745 41.9999 21.048 41.9999Z",
    fill: "url(#paint0_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.4922 13.2607C38.7577 13.4386 37.9968 13.4793 37.2475 13.3807C36.402 13.1707 36.0129 13.6131 35.4293 13.3132C35.0227 13.0915 34.5139 13.2422 34.2928 13.6497C34.2846 13.6648 34.2768 13.6802 34.2696 13.6957C34.1349 13.9807 33.6935 13.6957 33.4016 13.9508C33.0693 14.1223 32.6975 14.2025 32.3242 14.1832C32.3242 14.1832 34.8084 15.0982 39.4923 13.2607H39.4922Z",
    fill: "url(#paint1_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.4922 13.2607C38.7577 13.4386 37.9968 13.4793 37.2475 13.3807C36.402 13.1707 36.0129 13.6131 35.4293 13.3132C35.0227 13.0915 34.5139 13.2422 34.2928 13.6497C34.2846 13.6648 34.2768 13.6802 34.2696 13.6957C34.1349 13.9807 33.6935 13.6957 33.4016 13.9508C33.0693 14.1223 32.6975 14.2025 32.3242 14.1832C32.3242 14.1832 34.8084 15.0982 39.4923 13.2607H39.4922Z",
    fill: "url(#paint2_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.3034 14.2502C27.0237 14.4514 26.7161 14.6106 26.3906 14.7227C26.3906 14.7227 29.2189 15.1877 30.5358 14.6101C30.1382 14.56 29.7528 14.4381 29.3985 14.2501C28.9949 13.9817 28.4703 13.9817 28.0667 14.2501C27.7823 14.5126 27.6327 14.0101 27.3034 14.2501V14.2502Z",
    fill: "url(#paint3_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.3034 14.2502C27.0237 14.4514 26.7161 14.6106 26.3906 14.7227C26.3906 14.7227 29.2189 15.1877 30.5358 14.6101C30.1382 14.56 29.7528 14.4381 29.3985 14.2501C28.9949 13.9817 28.4703 13.9817 28.0667 14.2501C27.7823 14.5126 27.6327 14.0101 27.3034 14.2501V14.2502Z",
    fill: "url(#paint4_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.5763 17.7451C33.1715 17.4194 32.6663 17.2445 32.1472 17.2501H29.6406V18.0001C30.9572 18.0203 32.2733 17.935 33.5763 17.7451Z",
    fill: "url(#paint5_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.5763 17.7451C33.1715 17.4194 32.6663 17.2445 32.1472 17.2501H29.6406V18.0001C30.9572 18.0203 32.2733 17.935 33.5763 17.7451Z",
    fill: "url(#paint6_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.5763 17.7451C33.1715 17.4194 32.6663 17.2445 32.1472 17.2501H29.6406V18.0001C30.9572 18.0203 32.2733 17.935 33.5763 17.7451Z",
    fill: "url(#paint7_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.707 17.9996V23.1745H25.104V17.707C23.9876 17.9413 22.8469 18.0395 21.707 17.9995V17.9996Z",
    fill: "url(#paint8_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25.3003 17.6543H25.1133V17.7067L25.3003 17.6543Z",
    fill: "url(#paint9_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.7519 16.9506L21.707 16.8906V18.0006C22.8466 18.0431 23.9873 17.9474 25.104 17.7157V17.6631C24.4976 17.685 23.8941 17.5696 23.3382 17.3256C22.7846 16.9505 22.0363 17.3631 21.752 16.9505L21.7519 16.9506Z",
    fill: "url(#paint10_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.7519 16.9506L21.707 16.8906V18.0006C22.8466 18.0431 23.9873 17.9474 25.104 17.7157V17.6631C24.4976 17.685 23.8941 17.5696 23.3382 17.3256C22.7846 16.9505 22.0363 17.3631 21.752 16.9505L21.7519 16.9506Z",
    fill: "url(#paint11_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.4021 16.5009C15.0719 16.6448 13.7278 16.5892 12.4141 16.3359C13.8882 16.7973 15.3871 17.1754 16.9034 17.4684V16.426C16.735 16.4404 16.5675 16.4655 16.4021 16.501V16.5009Z",
    fill: "url(#paint12_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M16.4021 16.5009C15.0719 16.6448 13.7278 16.5892 12.4141 16.3359C13.8882 16.7973 15.3871 17.1754 16.9034 17.4684V16.426C16.735 16.4404 16.5675 16.4655 16.4021 16.501V16.5009Z",
    fill: "url(#paint13_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M21.7095 16.8899C21.2099 16.2741 20.36 16.0711 19.6369 16.395C18.7615 16.785 18.0582 16.3275 16.8984 16.395V17.4374C18.4841 17.7508 20.0938 17.9265 21.7095 17.9624V16.8899Z",
    fill: "url(#paint14_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M21.7095 16.8899C21.2099 16.2741 20.36 16.0711 19.6369 16.395C18.7615 16.785 18.0582 16.3275 16.8984 16.395V17.4374C18.4841 17.7508 20.0938 17.9265 21.7095 17.9624V16.8899Z",
    fill: "url(#paint15_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M21.7095 16.8899C21.2099 16.2741 20.36 16.0711 19.6369 16.395C18.7615 16.785 18.0582 16.3275 16.8984 16.395V17.4374C18.4841 17.7508 20.0938 17.9265 21.7095 17.9624V16.8899Z",
    fill: "url(#paint16_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M4.55696 17.5352H4.99088C5.01153 17.5352 5.02831 17.552 5.02831 17.5727V18.0076C5.02831 18.0283 5.01153 18.0451 4.99088 18.0451H4.55696C4.53631 18.0451 4.51953 18.0283 4.51953 18.0076V17.5727C4.51953 17.552 4.53631 17.5352 4.55696 17.5352Z",
    fill: "url(#paint17_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M4.55696 17.5352H4.99088C5.01153 17.5352 5.02831 17.552 5.02831 17.5727V18.0076C5.02831 18.0283 5.01153 18.0451 4.99088 18.0451H4.55696C4.53631 18.0451 4.51953 18.0283 4.51953 18.0076V17.5727C4.51953 17.552 4.53631 17.5352 4.55696 17.5352Z",
    fill: "url(#paint18_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M4.55696 17.5352H4.99088C5.01153 17.5352 5.02831 17.552 5.02831 17.5727V18.0076C5.02831 18.0283 5.01153 18.0451 4.99088 18.0451H4.55696C4.53631 18.0451 4.51953 18.0283 4.51953 18.0076V17.5727C4.51953 17.552 4.53631 17.5352 4.55696 17.5352Z",
    fill: "url(#paint19_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M5.87369 17.5352H5.43977C5.4191 17.5352 5.40234 17.552 5.40234 17.5727V18.0076C5.40234 18.0283 5.4191 18.0451 5.43977 18.0451H5.87369C5.89436 18.0451 5.91112 18.0283 5.91112 18.0076V17.5727C5.91112 17.552 5.89436 17.5352 5.87369 17.5352Z",
    fill: "url(#paint20_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M5.87369 17.5352H5.43977C5.4191 17.5352 5.40234 17.552 5.40234 17.5727V18.0076C5.40234 18.0283 5.4191 18.0451 5.43977 18.0451H5.87369C5.89436 18.0451 5.91112 18.0283 5.91112 18.0076V17.5727C5.91112 17.552 5.89436 17.5352 5.87369 17.5352Z",
    fill: "url(#paint21_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M5.87369 17.5352H5.43977C5.4191 17.5352 5.40234 17.552 5.40234 17.5727V18.0076C5.40234 18.0283 5.4191 18.0451 5.43977 18.0451H5.87369C5.89436 18.0451 5.91112 18.0283 5.91112 18.0076V17.5727C5.91112 17.552 5.89436 17.5352 5.87369 17.5352Z",
    fill: "url(#paint22_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M6.31868 17.5352H6.7526C6.77325 17.5352 6.79003 17.552 6.79003 17.5727V18.0076C6.79003 18.0283 6.77325 18.0451 6.7526 18.0451H6.31868C6.29802 18.0451 6.28125 18.0283 6.28125 18.0076V17.5727C6.28125 17.552 6.29802 17.5352 6.31868 17.5352Z",
    fill: "url(#paint23_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M6.31868 17.5352H6.7526C6.77325 17.5352 6.79003 17.552 6.79003 17.5727V18.0076C6.79003 18.0283 6.77325 18.0451 6.7526 18.0451H6.31868C6.29802 18.0451 6.28125 18.0283 6.28125 18.0076V17.5727C6.28125 17.552 6.29802 17.5352 6.31868 17.5352Z",
    fill: "url(#paint24_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M6.31868 17.5352H6.7526C6.77325 17.5352 6.79003 17.552 6.79003 17.5727V18.0076C6.79003 18.0283 6.77325 18.0451 6.7526 18.0451H6.31868C6.29802 18.0451 6.28125 18.0283 6.28125 18.0076V17.5727C6.28125 17.552 6.29802 17.5352 6.31868 17.5352Z",
    fill: "url(#paint25_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M7.19368 17.5352H7.6276C7.64825 17.5352 7.66503 17.552 7.66503 17.5727V18.0076C7.66503 18.0283 7.64825 18.0451 7.6276 18.0451H7.19368C7.17302 18.0451 7.15625 18.0283 7.15625 18.0076V17.5727C7.15625 17.552 7.17302 17.5352 7.19368 17.5352Z",
    fill: "url(#paint26_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M7.19368 17.5352H7.6276C7.64825 17.5352 7.66503 17.552 7.66503 17.5727V18.0076C7.66503 18.0283 7.64825 18.0451 7.6276 18.0451H7.19368C7.17302 18.0451 7.15625 18.0283 7.15625 18.0076V17.5727C7.15625 17.552 7.17302 17.5352 7.19368 17.5352Z",
    fill: "url(#paint27_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M7.19368 17.5352H7.6276C7.64825 17.5352 7.66503 17.552 7.66503 17.5727V18.0076C7.66503 18.0283 7.64825 18.0451 7.6276 18.0451H7.19368C7.17302 18.0451 7.15625 18.0283 7.15625 18.0076V17.5727C7.15625 17.552 7.17302 17.5352 7.19368 17.5352Z",
    fill: "url(#paint28_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M8.07649 17.5352H8.51041C8.53107 17.5352 8.54784 17.552 8.54784 17.5727V18.0076C8.54784 18.0283 8.53107 18.0451 8.51041 18.0451H8.07649C8.05584 18.0451 8.03906 18.0283 8.03906 18.0076V17.5727C8.03906 17.552 8.05584 17.5352 8.07649 17.5352Z",
    fill: "url(#paint29_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M8.07649 17.5352H8.51041C8.53107 17.5352 8.54784 17.552 8.54784 17.5727V18.0076C8.54784 18.0283 8.53107 18.0451 8.51041 18.0451H8.07649C8.05584 18.0451 8.03906 18.0283 8.03906 18.0076V17.5727C8.03906 17.552 8.05584 17.5352 8.07649 17.5352Z",
    fill: "url(#paint30_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M8.07649 17.5352H8.51041C8.53107 17.5352 8.54784 17.552 8.54784 17.5727V18.0076C8.54784 18.0283 8.53107 18.0451 8.51041 18.0451H8.07649C8.05584 18.0451 8.03906 18.0283 8.03906 18.0076V17.5727C8.03906 17.552 8.05584 17.5352 8.07649 17.5352Z",
    fill: "url(#paint31_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M4.55696 18.4648H4.99088C5.01153 18.4648 5.02831 18.4817 5.02831 18.5024V18.9373C5.02831 18.958 5.01153 18.9748 4.99088 18.9748H4.55696C4.53631 18.9748 4.51953 18.958 4.51953 18.9373V18.5024C4.51953 18.4817 4.53631 18.4648 4.55696 18.4648Z",
    fill: "url(#paint32_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M4.55696 18.4648H4.99088C5.01153 18.4648 5.02831 18.4817 5.02831 18.5024V18.9373C5.02831 18.958 5.01153 18.9748 4.99088 18.9748H4.55696C4.53631 18.9748 4.51953 18.958 4.51953 18.9373V18.5024C4.51953 18.4817 4.53631 18.4648 4.55696 18.4648Z",
    fill: "url(#paint33_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M4.55696 18.4648H4.99088C5.01153 18.4648 5.02831 18.4817 5.02831 18.5024V18.9373C5.02831 18.958 5.01153 18.9748 4.99088 18.9748H4.55696C4.53631 18.9748 4.51953 18.958 4.51953 18.9373V18.5024C4.51953 18.4817 4.53631 18.4648 4.55696 18.4648Z",
    fill: "url(#paint34_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M5.43977 18.4648H5.87369C5.89435 18.4648 5.91112 18.4817 5.91112 18.5024V18.9373C5.91112 18.958 5.89435 18.9748 5.87369 18.9748H5.43977C5.41912 18.9748 5.40234 18.958 5.40234 18.9373V18.5024C5.40234 18.4817 5.41912 18.4648 5.43977 18.4648Z",
    fill: "url(#paint35_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M5.43977 18.4648H5.87369C5.89435 18.4648 5.91112 18.4817 5.91112 18.5024V18.9373C5.91112 18.958 5.89435 18.9748 5.87369 18.9748H5.43977C5.41912 18.9748 5.40234 18.958 5.40234 18.9373V18.5024C5.40234 18.4817 5.41912 18.4648 5.43977 18.4648Z",
    fill: "url(#paint36_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M5.43977 18.4648H5.87369C5.89435 18.4648 5.91112 18.4817 5.91112 18.5024V18.9373C5.91112 18.958 5.89435 18.9748 5.87369 18.9748H5.43977C5.41912 18.9748 5.40234 18.958 5.40234 18.9373V18.5024C5.40234 18.4817 5.41912 18.4648 5.43977 18.4648Z",
    fill: "url(#paint37_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M6.31868 18.4648H6.7526C6.77325 18.4648 6.79003 18.4817 6.79003 18.5024V18.9373C6.79003 18.958 6.77325 18.9748 6.7526 18.9748H6.31868C6.29802 18.9748 6.28125 18.958 6.28125 18.9373V18.5024C6.28125 18.4817 6.29802 18.4648 6.31868 18.4648Z",
    fill: "url(#paint38_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M6.31868 18.4648H6.7526C6.77325 18.4648 6.79003 18.4817 6.79003 18.5024V18.9373C6.79003 18.958 6.77325 18.9748 6.7526 18.9748H6.31868C6.29802 18.9748 6.28125 18.958 6.28125 18.9373V18.5024C6.28125 18.4817 6.29802 18.4648 6.31868 18.4648Z",
    fill: "url(#paint39_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M6.31868 18.4648H6.7526C6.77325 18.4648 6.79003 18.4817 6.79003 18.5024V18.9373C6.79003 18.958 6.77325 18.9748 6.7526 18.9748H6.31868C6.29802 18.9748 6.28125 18.958 6.28125 18.9373V18.5024C6.28125 18.4817 6.29802 18.4648 6.31868 18.4648Z",
    fill: "url(#paint40_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M7.19368 18.4648H7.6276C7.64825 18.4648 7.66503 18.4817 7.66503 18.5024V18.9373C7.66503 18.958 7.64825 18.9748 7.6276 18.9748H7.19368C7.17302 18.9748 7.15625 18.958 7.15625 18.9373V18.5024C7.15625 18.4817 7.17302 18.4648 7.19368 18.4648Z",
    fill: "url(#paint41_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M7.19368 18.4648H7.6276C7.64825 18.4648 7.66503 18.4817 7.66503 18.5024V18.9373C7.66503 18.958 7.64825 18.9748 7.6276 18.9748H7.19368C7.17302 18.9748 7.15625 18.958 7.15625 18.9373V18.5024C7.15625 18.4817 7.17302 18.4648 7.19368 18.4648Z",
    fill: "url(#paint42_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M7.19368 18.4648H7.6276C7.64825 18.4648 7.66503 18.4817 7.66503 18.5024V18.9373C7.66503 18.958 7.64825 18.9748 7.6276 18.9748H7.19368C7.17302 18.9748 7.15625 18.958 7.15625 18.9373V18.5024C7.15625 18.4817 7.17302 18.4648 7.19368 18.4648Z",
    fill: "url(#paint43_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M8.07649 18.4648H8.51041C8.53107 18.4648 8.54784 18.4817 8.54784 18.5024V18.9373C8.54784 18.958 8.53107 18.9748 8.51041 18.9748H8.07649C8.05584 18.9748 8.03906 18.958 8.03906 18.9373V18.5024C8.03906 18.4817 8.05584 18.4648 8.07649 18.4648Z",
    fill: "url(#paint44_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M8.07649 18.4648H8.51041C8.53107 18.4648 8.54784 18.4817 8.54784 18.5024V18.9373C8.54784 18.958 8.53107 18.9748 8.51041 18.9748H8.07649C8.05584 18.9748 8.03906 18.958 8.03906 18.9373V18.5024C8.03906 18.4817 8.05584 18.4648 8.07649 18.4648Z",
    fill: "url(#paint45_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M8.07649 18.4648H8.51041C8.53107 18.4648 8.54784 18.4817 8.54784 18.5024V18.9373C8.54784 18.958 8.53107 18.9748 8.51041 18.9748H8.07649C8.05584 18.9748 8.03906 18.958 8.03906 18.9373V18.5024C8.03906 18.4817 8.05584 18.4648 8.07649 18.4648Z",
    fill: "url(#paint46_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M4.55696 19.3945H4.99088C5.01153 19.3945 5.02831 19.4113 5.02831 19.432V19.867C5.02831 19.8877 5.01153 19.9045 4.99088 19.9045H4.55696C4.53631 19.9045 4.51953 19.8877 4.51953 19.867V19.432C4.51953 19.4113 4.53631 19.3945 4.55696 19.3945Z",
    fill: "url(#paint47_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M4.55696 19.3945H4.99088C5.01153 19.3945 5.02831 19.4113 5.02831 19.432V19.867C5.02831 19.8877 5.01153 19.9045 4.99088 19.9045H4.55696C4.53631 19.9045 4.51953 19.8877 4.51953 19.867V19.432C4.51953 19.4113 4.53631 19.3945 4.55696 19.3945Z",
    fill: "url(#paint48_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M4.55696 19.3945H4.99088C5.01153 19.3945 5.02831 19.4113 5.02831 19.432V19.867C5.02831 19.8877 5.01153 19.9045 4.99088 19.9045H4.55696C4.53631 19.9045 4.51953 19.8877 4.51953 19.867V19.432C4.51953 19.4113 4.53631 19.3945 4.55696 19.3945Z",
    fill: "url(#paint49_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M5.87369 19.3945H5.43977C5.4191 19.3945 5.40234 19.4113 5.40234 19.432V19.867C5.40234 19.8877 5.4191 19.9045 5.43977 19.9045H5.87369C5.89436 19.9045 5.91112 19.8877 5.91112 19.867V19.432C5.91112 19.4113 5.89436 19.3945 5.87369 19.3945Z",
    fill: "url(#paint50_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M5.87369 19.3945H5.43977C5.4191 19.3945 5.40234 19.4113 5.40234 19.432V19.867C5.40234 19.8877 5.4191 19.9045 5.43977 19.9045H5.87369C5.89436 19.9045 5.91112 19.8877 5.91112 19.867V19.432C5.91112 19.4113 5.89436 19.3945 5.87369 19.3945Z",
    fill: "url(#paint51_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M5.87369 19.3945H5.43977C5.4191 19.3945 5.40234 19.4113 5.40234 19.432V19.867C5.40234 19.8877 5.4191 19.9045 5.43977 19.9045H5.87369C5.89436 19.9045 5.91112 19.8877 5.91112 19.867V19.432C5.91112 19.4113 5.89436 19.3945 5.87369 19.3945Z",
    fill: "url(#paint52_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M6.7526 19.3945H6.31868C6.29801 19.3945 6.28125 19.4113 6.28125 19.432V19.867C6.28125 19.8877 6.29801 19.9045 6.31868 19.9045H6.7526C6.77327 19.9045 6.79003 19.8877 6.79003 19.867V19.432C6.79003 19.4113 6.77327 19.3945 6.7526 19.3945Z",
    fill: "url(#paint53_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M6.7526 19.3945H6.31868C6.29801 19.3945 6.28125 19.4113 6.28125 19.432V19.867C6.28125 19.8877 6.29801 19.9045 6.31868 19.9045H6.7526C6.77327 19.9045 6.79003 19.8877 6.79003 19.867V19.432C6.79003 19.4113 6.77327 19.3945 6.7526 19.3945Z",
    fill: "url(#paint54_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M6.7526 19.3945H6.31868C6.29801 19.3945 6.28125 19.4113 6.28125 19.432V19.867C6.28125 19.8877 6.29801 19.9045 6.31868 19.9045H6.7526C6.77327 19.9045 6.79003 19.8877 6.79003 19.867V19.432C6.79003 19.4113 6.77327 19.3945 6.7526 19.3945Z",
    fill: "url(#paint55_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M7.6276 19.3945H7.19368C7.17301 19.3945 7.15625 19.4113 7.15625 19.432V19.867C7.15625 19.8877 7.17301 19.9045 7.19368 19.9045H7.6276C7.64827 19.9045 7.66503 19.8877 7.66503 19.867V19.432C7.66503 19.4113 7.64827 19.3945 7.6276 19.3945Z",
    fill: "url(#paint56_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M7.6276 19.3945H7.19368C7.17301 19.3945 7.15625 19.4113 7.15625 19.432V19.867C7.15625 19.8877 7.17301 19.9045 7.19368 19.9045H7.6276C7.64827 19.9045 7.66503 19.8877 7.66503 19.867V19.432C7.66503 19.4113 7.64827 19.3945 7.6276 19.3945Z",
    fill: "url(#paint57_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M7.6276 19.3945H7.19368C7.17301 19.3945 7.15625 19.4113 7.15625 19.432V19.867C7.15625 19.8877 7.17301 19.9045 7.19368 19.9045H7.6276C7.64827 19.9045 7.66503 19.8877 7.66503 19.867V19.432C7.66503 19.4113 7.64827 19.3945 7.6276 19.3945Z",
    fill: "url(#paint58_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M8.07649 19.3945H8.51041C8.53107 19.3945 8.54784 19.4113 8.54784 19.432V19.867C8.54784 19.8877 8.53107 19.9045 8.51041 19.9045H8.07649C8.05584 19.9045 8.03906 19.8877 8.03906 19.867V19.432C8.03906 19.4113 8.05584 19.3945 8.07649 19.3945Z",
    fill: "url(#paint59_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M8.07649 19.3945H8.51041C8.53107 19.3945 8.54784 19.4113 8.54784 19.432V19.867C8.54784 19.8877 8.53107 19.9045 8.51041 19.9045H8.07649C8.05584 19.9045 8.03906 19.8877 8.03906 19.867V19.432C8.03906 19.4113 8.05584 19.3945 8.07649 19.3945Z",
    fill: "url(#paint60_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M8.07649 19.3945H8.51041C8.53107 19.3945 8.54784 19.4113 8.54784 19.432V19.867C8.54784 19.8877 8.53107 19.9045 8.51041 19.9045H8.07649C8.05584 19.9045 8.03906 19.8877 8.03906 19.867V19.432C8.03906 19.4113 8.05584 19.3945 8.07649 19.3945Z",
    fill: "url(#paint61_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M4.55696 20.3184H4.99088C5.01153 20.3184 5.02831 20.3352 5.02831 20.3559V20.7908C5.02831 20.8115 5.01153 20.8283 4.99088 20.8283H4.55696C4.53631 20.8283 4.51953 20.8115 4.51953 20.7908V20.3559C4.51953 20.3352 4.53631 20.3184 4.55696 20.3184Z",
    fill: "url(#paint62_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M4.55696 20.3184H4.99088C5.01153 20.3184 5.02831 20.3352 5.02831 20.3559V20.7908C5.02831 20.8115 5.01153 20.8283 4.99088 20.8283H4.55696C4.53631 20.8283 4.51953 20.8115 4.51953 20.7908V20.3559C4.51953 20.3352 4.53631 20.3184 4.55696 20.3184Z",
    fill: "url(#paint63_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M4.55696 20.3184H4.99088C5.01153 20.3184 5.02831 20.3352 5.02831 20.3559V20.7908C5.02831 20.8115 5.01153 20.8283 4.99088 20.8283H4.55696C4.53631 20.8283 4.51953 20.8115 4.51953 20.7908V20.3559C4.51953 20.3352 4.53631 20.3184 4.55696 20.3184Z",
    fill: "url(#paint64_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M5.43977 20.3184H5.87369C5.89435 20.3184 5.91112 20.3352 5.91112 20.3559V20.7908C5.91112 20.8115 5.89435 20.8283 5.87369 20.8283H5.43977C5.41912 20.8283 5.40234 20.8115 5.40234 20.7908V20.3559C5.40234 20.3352 5.41912 20.3184 5.43977 20.3184Z",
    fill: "url(#paint65_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M5.43977 20.3184H5.87369C5.89435 20.3184 5.91112 20.3352 5.91112 20.3559V20.7908C5.91112 20.8115 5.89435 20.8283 5.87369 20.8283H5.43977C5.41912 20.8283 5.40234 20.8115 5.40234 20.7908V20.3559C5.40234 20.3352 5.41912 20.3184 5.43977 20.3184Z",
    fill: "url(#paint66_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M5.43977 20.3184H5.87369C5.89435 20.3184 5.91112 20.3352 5.91112 20.3559V20.7908C5.91112 20.8115 5.89435 20.8283 5.87369 20.8283H5.43977C5.41912 20.8283 5.40234 20.8115 5.40234 20.7908V20.3559C5.40234 20.3352 5.41912 20.3184 5.43977 20.3184Z",
    fill: "url(#paint67_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M6.31868 20.3184H6.7526C6.77325 20.3184 6.79003 20.3352 6.79003 20.3559V20.7908C6.79003 20.8115 6.77325 20.8283 6.7526 20.8283H6.31868C6.29802 20.8283 6.28125 20.8115 6.28125 20.7908V20.3559C6.28125 20.3352 6.29802 20.3184 6.31868 20.3184Z",
    fill: "url(#paint68_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M6.31868 20.3184H6.7526C6.77325 20.3184 6.79003 20.3352 6.79003 20.3559V20.7908C6.79003 20.8115 6.77325 20.8283 6.7526 20.8283H6.31868C6.29802 20.8283 6.28125 20.8115 6.28125 20.7908V20.3559C6.28125 20.3352 6.29802 20.3184 6.31868 20.3184Z",
    fill: "url(#paint69_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M6.31868 20.3184H6.7526C6.77325 20.3184 6.79003 20.3352 6.79003 20.3559V20.7908C6.79003 20.8115 6.77325 20.8283 6.7526 20.8283H6.31868C6.29802 20.8283 6.28125 20.8115 6.28125 20.7908V20.3559C6.28125 20.3352 6.29802 20.3184 6.31868 20.3184Z",
    fill: "url(#paint70_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M7.19368 20.3184H7.6276C7.64825 20.3184 7.66503 20.3352 7.66503 20.3559V20.7908C7.66503 20.8115 7.64825 20.8283 7.6276 20.8283H7.19368C7.17302 20.8283 7.15625 20.8115 7.15625 20.7908V20.3559C7.15625 20.3352 7.17302 20.3184 7.19368 20.3184Z",
    fill: "url(#paint71_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M7.19368 20.3184H7.6276C7.64825 20.3184 7.66503 20.3352 7.66503 20.3559V20.7908C7.66503 20.8115 7.64825 20.8283 7.6276 20.8283H7.19368C7.17302 20.8283 7.15625 20.8115 7.15625 20.7908V20.3559C7.15625 20.3352 7.17302 20.3184 7.19368 20.3184Z",
    fill: "url(#paint72_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M7.19368 20.3184H7.6276C7.64825 20.3184 7.66503 20.3352 7.66503 20.3559V20.7908C7.66503 20.8115 7.64825 20.8283 7.6276 20.8283H7.19368C7.17302 20.8283 7.15625 20.8115 7.15625 20.7908V20.3559C7.15625 20.3352 7.17302 20.3184 7.19368 20.3184Z",
    fill: "url(#paint73_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M8.51041 20.3184H8.07649C8.05582 20.3184 8.03906 20.3352 8.03906 20.3559V20.7908C8.03906 20.8115 8.05582 20.8283 8.07649 20.8283H8.51041C8.53108 20.8283 8.54784 20.8115 8.54784 20.7908V20.3559C8.54784 20.3352 8.53108 20.3184 8.51041 20.3184Z",
    fill: "url(#paint74_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M8.51041 20.3184H8.07649C8.05582 20.3184 8.03906 20.3352 8.03906 20.3559V20.7908C8.03906 20.8115 8.05582 20.8283 8.07649 20.8283H8.51041C8.53108 20.8283 8.54784 20.8115 8.54784 20.7908V20.3559C8.54784 20.3352 8.53108 20.3184 8.51041 20.3184Z",
    fill: "url(#paint75_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M8.51041 20.3184H8.07649C8.05582 20.3184 8.03906 20.3352 8.03906 20.3559V20.7908C8.03906 20.8115 8.05582 20.8283 8.07649 20.8283H8.51041C8.53108 20.8283 8.54784 20.8115 8.54784 20.7908V20.3559C8.54784 20.3352 8.53108 20.3184 8.51041 20.3184Z",
    fill: "url(#paint76_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M6.31868 21.248H6.7526C6.77325 21.248 6.79003 21.2649 6.79003 21.2856V21.7205C6.79003 21.7412 6.77325 21.758 6.7526 21.758H6.31868C6.29802 21.758 6.28125 21.7412 6.28125 21.7205V21.2856C6.28125 21.2649 6.29802 21.248 6.31868 21.248Z",
    fill: "url(#paint77_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M6.31868 21.248H6.7526C6.77325 21.248 6.79003 21.2649 6.79003 21.2856V21.7205C6.79003 21.7412 6.77325 21.758 6.7526 21.758H6.31868C6.29802 21.758 6.28125 21.7412 6.28125 21.7205V21.2856C6.28125 21.2649 6.29802 21.248 6.31868 21.248Z",
    fill: "url(#paint78_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M6.31868 21.248H6.7526C6.77325 21.248 6.79003 21.2649 6.79003 21.2856V21.7205C6.79003 21.7412 6.77325 21.758 6.7526 21.758H6.31868C6.29802 21.758 6.28125 21.7412 6.28125 21.7205V21.2856C6.28125 21.2649 6.29802 21.248 6.31868 21.248Z",
    fill: "url(#paint79_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M7.19368 21.248H7.6276C7.64825 21.248 7.66503 21.2649 7.66503 21.2856V21.7205C7.66503 21.7412 7.64825 21.758 7.6276 21.758H7.19368C7.17302 21.758 7.15625 21.7412 7.15625 21.7205V21.2856C7.15625 21.2649 7.17302 21.248 7.19368 21.248Z",
    fill: "url(#paint80_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M7.19368 21.248H7.6276C7.64825 21.248 7.66503 21.2649 7.66503 21.2856V21.7205C7.66503 21.7412 7.64825 21.758 7.6276 21.758H7.19368C7.17302 21.758 7.15625 21.7412 7.15625 21.7205V21.2856C7.15625 21.2649 7.17302 21.248 7.19368 21.248Z",
    fill: "url(#paint81_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M7.19368 21.248H7.6276C7.64825 21.248 7.66503 21.2649 7.66503 21.2856V21.7205C7.66503 21.7412 7.64825 21.758 7.6276 21.758H7.19368C7.17302 21.758 7.15625 21.7412 7.15625 21.7205V21.2856C7.15625 21.2649 7.17302 21.248 7.19368 21.248Z",
    fill: "url(#paint82_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M8.07649 21.248H8.51041C8.53107 21.248 8.54784 21.2649 8.54784 21.2856V21.7205C8.54784 21.7412 8.53107 21.758 8.51041 21.758H8.07649C8.05584 21.758 8.03906 21.7412 8.03906 21.7205V21.2856C8.03906 21.2649 8.05584 21.248 8.07649 21.248Z",
    fill: "url(#paint83_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M8.07649 21.248H8.51041C8.53107 21.248 8.54784 21.2649 8.54784 21.2856V21.7205C8.54784 21.7412 8.53107 21.758 8.51041 21.758H8.07649C8.05584 21.758 8.03906 21.7412 8.03906 21.7205V21.2856C8.03906 21.2649 8.05584 21.248 8.07649 21.248Z",
    fill: "url(#paint84_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M8.07649 21.248H8.51041C8.53107 21.248 8.54784 21.2649 8.54784 21.2856V21.7205C8.54784 21.7412 8.53107 21.758 8.51041 21.758H8.07649C8.05584 21.758 8.03906 21.7412 8.03906 21.7205V21.2856C8.03906 21.2649 8.05584 21.248 8.07649 21.248Z",
    fill: "url(#paint85_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M6.31868 22.1777H6.7526C6.77325 22.1777 6.79003 22.1945 6.79003 22.2153V22.6502C6.79003 22.6709 6.77325 22.6877 6.7526 22.6877H6.31868C6.29802 22.6877 6.28125 22.6709 6.28125 22.6502V22.2153C6.28125 22.1945 6.29802 22.1777 6.31868 22.1777Z",
    fill: "url(#paint86_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M6.31868 22.1777H6.7526C6.77325 22.1777 6.79003 22.1945 6.79003 22.2153V22.6502C6.79003 22.6709 6.77325 22.6877 6.7526 22.6877H6.31868C6.29802 22.6877 6.28125 22.6709 6.28125 22.6502V22.2153C6.28125 22.1945 6.29802 22.1777 6.31868 22.1777Z",
    fill: "url(#paint87_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M6.31868 22.1777H6.7526C6.77325 22.1777 6.79003 22.1945 6.79003 22.2153V22.6502C6.79003 22.6709 6.77325 22.6877 6.7526 22.6877H6.31868C6.29802 22.6877 6.28125 22.6709 6.28125 22.6502V22.2153C6.28125 22.1945 6.29802 22.1777 6.31868 22.1777Z",
    fill: "url(#paint88_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M7.19368 22.1777H7.6276C7.64825 22.1777 7.66503 22.1945 7.66503 22.2153V22.6502C7.66503 22.6709 7.64825 22.6877 7.6276 22.6877H7.19368C7.17302 22.6877 7.15625 22.6709 7.15625 22.6502V22.2153C7.15625 22.1945 7.17302 22.1777 7.19368 22.1777Z",
    fill: "url(#paint89_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M7.19368 22.1777H7.6276C7.64825 22.1777 7.66503 22.1945 7.66503 22.2153V22.6502C7.66503 22.6709 7.64825 22.6877 7.6276 22.6877H7.19368C7.17302 22.6877 7.15625 22.6709 7.15625 22.6502V22.2153C7.15625 22.1945 7.17302 22.1777 7.19368 22.1777Z",
    fill: "url(#paint90_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M7.19368 22.1777H7.6276C7.64825 22.1777 7.66503 22.1945 7.66503 22.2153V22.6502C7.66503 22.6709 7.64825 22.6877 7.6276 22.6877H7.19368C7.17302 22.6877 7.15625 22.6709 7.15625 22.6502V22.2153C7.15625 22.1945 7.17302 22.1777 7.19368 22.1777Z",
    fill: "url(#paint91_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M8.51041 22.1777H8.07649C8.05582 22.1777 8.03906 22.1945 8.03906 22.2153V22.6502C8.03906 22.6709 8.05582 22.6877 8.07649 22.6877H8.51041C8.53108 22.6877 8.54784 22.6709 8.54784 22.6502V22.2153C8.54784 22.1945 8.53108 22.1777 8.51041 22.1777Z",
    fill: "url(#paint92_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M8.51041 22.1777H8.07649C8.05582 22.1777 8.03906 22.1945 8.03906 22.2153V22.6502C8.03906 22.6709 8.05582 22.6877 8.07649 22.6877H8.51041C8.53108 22.6877 8.54784 22.6709 8.54784 22.6502V22.2153C8.54784 22.1945 8.53108 22.1777 8.51041 22.1777Z",
    fill: "url(#paint93_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M8.51041 22.1777H8.07649C8.05582 22.1777 8.03906 22.1945 8.03906 22.2153V22.6502C8.03906 22.6709 8.05582 22.6877 8.07649 22.6877H8.51041C8.53108 22.6877 8.54784 22.6709 8.54784 22.6502V22.2153C8.54784 22.1945 8.53108 22.1777 8.51041 22.1777Z",
    fill: "url(#paint94_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M6.31868 23.0996H6.7526C6.77325 23.0996 6.79003 23.1164 6.79003 23.1371V23.5721C6.79003 23.5928 6.77325 23.6096 6.7526 23.6096H6.31868C6.29802 23.6096 6.28125 23.5928 6.28125 23.5721V23.1371C6.28125 23.1164 6.29802 23.0996 6.31868 23.0996Z",
    fill: "url(#paint95_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M6.31868 23.0996H6.7526C6.77325 23.0996 6.79003 23.1164 6.79003 23.1371V23.5721C6.79003 23.5928 6.77325 23.6096 6.7526 23.6096H6.31868C6.29802 23.6096 6.28125 23.5928 6.28125 23.5721V23.1371C6.28125 23.1164 6.29802 23.0996 6.31868 23.0996Z",
    fill: "url(#paint96_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M6.31868 23.0996H6.7526C6.77325 23.0996 6.79003 23.1164 6.79003 23.1371V23.5721C6.79003 23.5928 6.77325 23.6096 6.7526 23.6096H6.31868C6.29802 23.6096 6.28125 23.5928 6.28125 23.5721V23.1371C6.28125 23.1164 6.29802 23.0996 6.31868 23.0996Z",
    fill: "url(#paint97_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M7.6276 23.0996H7.19368C7.17301 23.0996 7.15625 23.1164 7.15625 23.1371V23.5721C7.15625 23.5928 7.17301 23.6096 7.19368 23.6096H7.6276C7.64827 23.6096 7.66503 23.5928 7.66503 23.5721V23.1371C7.66503 23.1164 7.64827 23.0996 7.6276 23.0996Z",
    fill: "url(#paint98_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M7.6276 23.0996H7.19368C7.17301 23.0996 7.15625 23.1164 7.15625 23.1371V23.5721C7.15625 23.5928 7.17301 23.6096 7.19368 23.6096H7.6276C7.64827 23.6096 7.66503 23.5928 7.66503 23.5721V23.1371C7.66503 23.1164 7.64827 23.0996 7.6276 23.0996Z",
    fill: "url(#paint99_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M7.6276 23.0996H7.19368C7.17301 23.0996 7.15625 23.1164 7.15625 23.1371V23.5721C7.15625 23.5928 7.17301 23.6096 7.19368 23.6096H7.6276C7.64827 23.6096 7.66503 23.5928 7.66503 23.5721V23.1371C7.66503 23.1164 7.64827 23.0996 7.6276 23.0996Z",
    fill: "url(#paint100_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M8.07649 23.0996H8.51041C8.53107 23.0996 8.54784 23.1164 8.54784 23.1371V23.5721C8.54784 23.5928 8.53107 23.6096 8.51041 23.6096H8.07649C8.05584 23.6096 8.03906 23.5928 8.03906 23.5721V23.1371C8.03906 23.1164 8.05584 23.0996 8.07649 23.0996Z",
    fill: "url(#paint101_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M8.07649 23.0996H8.51041C8.53107 23.0996 8.54784 23.1164 8.54784 23.1371V23.5721C8.54784 23.5928 8.53107 23.6096 8.51041 23.6096H8.07649C8.05584 23.6096 8.03906 23.5928 8.03906 23.5721V23.1371C8.03906 23.1164 8.05584 23.0996 8.07649 23.0996Z",
    fill: "url(#paint102_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M8.07649 23.0996H8.51041C8.53107 23.0996 8.54784 23.1164 8.54784 23.1371V23.5721C8.54784 23.5928 8.53107 23.6096 8.51041 23.6096H8.07649C8.05584 23.6096 8.03906 23.5928 8.03906 23.5721V23.1371C8.03906 23.1164 8.05584 23.0996 8.07649 23.0996Z",
    fill: "url(#paint103_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M6.31868 24.0293H6.7526C6.77325 24.0293 6.79003 24.0461 6.79003 24.0668V24.5018C6.79003 24.5225 6.77325 24.5393 6.7526 24.5393H6.31868C6.29802 24.5393 6.28125 24.5225 6.28125 24.5018V24.0668C6.28125 24.0461 6.29802 24.0293 6.31868 24.0293Z",
    fill: "url(#paint104_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M6.31868 24.0293H6.7526C6.77325 24.0293 6.79003 24.0461 6.79003 24.0668V24.5018C6.79003 24.5225 6.77325 24.5393 6.7526 24.5393H6.31868C6.29802 24.5393 6.28125 24.5225 6.28125 24.5018V24.0668C6.28125 24.0461 6.29802 24.0293 6.31868 24.0293Z",
    fill: "url(#paint105_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M6.31868 24.0293H6.7526C6.77325 24.0293 6.79003 24.0461 6.79003 24.0668V24.5018C6.79003 24.5225 6.77325 24.5393 6.7526 24.5393H6.31868C6.29802 24.5393 6.28125 24.5225 6.28125 24.5018V24.0668C6.28125 24.0461 6.29802 24.0293 6.31868 24.0293Z",
    fill: "url(#paint106_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M6.31868 24.0293H6.7526C6.77325 24.0293 6.79003 24.0461 6.79003 24.0668V24.5018C6.79003 24.5225 6.77325 24.5393 6.7526 24.5393H6.31868C6.29802 24.5393 6.28125 24.5225 6.28125 24.5018V24.0668C6.28125 24.0461 6.29802 24.0293 6.31868 24.0293Z",
    fill: "url(#paint107_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M7.6276 24.0293H7.19368C7.17301 24.0293 7.15625 24.0461 7.15625 24.0668V24.5018C7.15625 24.5225 7.17301 24.5393 7.19368 24.5393H7.6276C7.64827 24.5393 7.66503 24.5225 7.66503 24.5018V24.0668C7.66503 24.0461 7.64827 24.0293 7.6276 24.0293Z",
    fill: "url(#paint108_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M7.6276 24.0293H7.19368C7.17301 24.0293 7.15625 24.0461 7.15625 24.0668V24.5018C7.15625 24.5225 7.17301 24.5393 7.19368 24.5393H7.6276C7.64827 24.5393 7.66503 24.5225 7.66503 24.5018V24.0668C7.66503 24.0461 7.64827 24.0293 7.6276 24.0293Z",
    fill: "url(#paint109_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M7.6276 24.0293H7.19368C7.17301 24.0293 7.15625 24.0461 7.15625 24.0668V24.5018C7.15625 24.5225 7.17301 24.5393 7.19368 24.5393H7.6276C7.64827 24.5393 7.66503 24.5225 7.66503 24.5018V24.0668C7.66503 24.0461 7.64827 24.0293 7.6276 24.0293Z",
    fill: "url(#paint110_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M7.6276 24.0293H7.19368C7.17301 24.0293 7.15625 24.0461 7.15625 24.0668V24.5018C7.15625 24.5225 7.17301 24.5393 7.19368 24.5393H7.6276C7.64827 24.5393 7.66503 24.5225 7.66503 24.5018V24.0668C7.66503 24.0461 7.64827 24.0293 7.6276 24.0293Z",
    fill: "url(#paint111_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M8.07649 24.0293H8.51041C8.53107 24.0293 8.54784 24.0461 8.54784 24.0668V24.5018C8.54784 24.5225 8.53107 24.5393 8.51041 24.5393H8.07649C8.05584 24.5393 8.03906 24.5225 8.03906 24.5018V24.0668C8.03906 24.0461 8.05584 24.0293 8.07649 24.0293Z",
    fill: "url(#paint112_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M8.07649 24.0293H8.51041C8.53107 24.0293 8.54784 24.0461 8.54784 24.0668V24.5018C8.54784 24.5225 8.53107 24.5393 8.51041 24.5393H8.07649C8.05584 24.5393 8.03906 24.5225 8.03906 24.5018V24.0668C8.03906 24.0461 8.05584 24.0293 8.07649 24.0293Z",
    fill: "url(#paint113_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M8.07649 24.0293H8.51041C8.53107 24.0293 8.54784 24.0461 8.54784 24.0668V24.5018C8.54784 24.5225 8.53107 24.5393 8.51041 24.5393H8.07649C8.05584 24.5393 8.03906 24.5225 8.03906 24.5018V24.0668C8.03906 24.0461 8.05584 24.0293 8.07649 24.0293Z",
    fill: "url(#paint114_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M18.0088 10.959H24.1577C24.2143 10.959 24.2603 11.005 24.2603 11.0618V16.1816C24.2603 16.2384 24.2143 16.2844 24.1577 16.2844H18.0088C17.9522 16.2844 17.9062 16.2384 17.9062 16.1816V11.0618C17.9062 11.005 17.9522 10.959 18.0088 10.959Z",
    fill: "#5DE2AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M18.1444 9.83398H24.021C24.2931 9.83398 24.5138 10.0552 24.5138 10.328V11.4508C24.5138 11.507 24.4684 11.5525 24.4124 11.5525H17.7576C17.7016 11.5525 17.6562 11.507 17.6562 11.4508V10.328C17.6562 10.057 17.874 9.83661 18.1444 9.83398Z",
    fill: "#64EDB9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M15.4736 10.959H21.6226C21.6792 10.959 21.7251 11.005 21.7251 11.0618V16.1816C21.7251 16.2384 21.6792 16.2844 21.6226 16.2844H15.4736C15.417 16.2844 15.3711 16.2384 15.3711 16.1816V11.0618C15.3711 11.005 15.417 10.959 15.4736 10.959Z",
    fill: "#32BF8C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    opacity: 0.49,
    d: "M15.4697 16.2825C15.4131 16.2825 15.3672 16.2364 15.3672 16.1797V11.0598C15.3672 11.0031 15.4131 10.957 15.4697 10.957L21.7189 11.5479",
    fill: "url(#paint115_linear_2881_52824)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M15.6085 9.83398H21.4851C21.7573 9.83398 21.978 10.0552 21.978 10.328V11.4508C21.978 11.507 21.9326 11.5525 21.8766 11.5525H15.2147C15.1587 11.5525 15.1133 11.507 15.1133 11.4508V10.328C15.1133 10.0552 15.334 9.83398 15.6061 9.83398C15.607 9.83398 15.6077 9.83398 15.6085 9.83398Z",
    fill: "#32BF8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M18.047 16.3199C19.4565 14.907 19.4565 12.6164 18.047 11.2036C16.6375 9.79072 14.3522 9.79072 12.9428 11.2036C11.5333 12.6164 11.5333 14.907 12.9428 16.3199C14.3522 17.7327 16.6375 17.7327 18.047 16.3199Z",
    fill: "#F4B401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M17.376 16.8484C18.2269 16.3278 18.0749 14.5231 17.0363 12.8177C15.9978 11.1123 14.466 10.1518 13.615 10.6725C12.7641 11.1931 12.9161 12.9978 13.9547 14.7032C14.9932 16.4086 16.525 17.3691 17.376 16.8484Z",
    fill: "#FFCE55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    opacity: 0.27,
    d: "M14.055 11.3894C12.4376 12.3779 11.926 14.4935 12.9121 16.1147C13.0184 16.2894 13.14 16.4543 13.2755 16.6074C14.848 17.8364 17.1167 17.5549 18.3428 15.9787C18.9813 15.1578 19.2363 14.101 19.0426 13.0783C18.3574 11.3081 16.3702 10.4297 14.6042 11.1165C14.4138 11.1906 14.2304 11.2815 14.0562 11.3882L14.055 11.3894Z",
    fill: "url(#paint116_linear_2881_52824)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M8.43001 4.97717L8.08803 5.73127C7.96306 6.00712 7.96956 6.32479 8.10575 6.59518L8.31092 7.00176C8.45622 7.29074 8.39908 7.64068 8.16938 7.86808L7.75318 8.28055C7.17647 8.85295 6.90032 9.66295 7.00684 10.4694C7.05989 10.8693 7.31475 11.2138 7.68126 11.3806C8.23271 11.6315 8.47677 12.2831 8.22642 12.8358C8.22631 12.8361 8.22621 12.8363 8.226 12.8367L8.01726 13.2976C7.79878 13.7792 7.67245 14.2975 7.64467 14.8257C7.60473 15.5874 7.79019 16.3439 8.17767 17.0004L8.96059 18.3253L10.3613 18.9635L11.8211 16.316C12.6413 14.8288 12.6139 13.0172 11.7492 11.5554C11.3508 10.8817 11.4389 10.0261 11.9661 9.44816L12.1688 9.22474C12.5643 8.79084 12.7968 8.23263 12.8268 7.64572L12.8468 7.25922C12.871 6.74419 12.5231 6.28591 12.0214 6.17189L11.3729 6.0253C11.0689 5.95636 10.8757 5.65655 10.9378 5.35044L11.1124 4.49829C11.295 3.59918 10.9136 2.67926 10.149 2.17474L10.1313 2.16297C9.58228 1.80116 8.84454 1.95406 8.48369 2.50439C8.44983 2.55599 8.42005 2.61022 8.39458 2.66644C8.21771 3.05694 8.18228 3.49704 8.29435 3.91097L8.46408 4.53739C8.50392 4.68346 8.49187 4.83888 8.42991 4.97707L8.43001 4.97717Z",
    fill: "url(#paint117_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M11.7497 11.5579C11.35 10.8835 11.4372 10.0267 11.9643 9.44702L12.167 9.22361C12.5625 8.78971 12.795 8.23149 12.825 7.64459L12.845 7.25808C12.8692 6.74306 12.5213 6.28478 12.0196 6.17076L11.3711 6.02416C11.0671 5.95523 10.8739 5.65542 10.936 5.3493L11.1093 4.49716C11.2925 3.59773 10.911 2.67707 10.146 2.17234L10.1283 2.16057H10.12C9.89888 2.01535 9.60208 2.07724 9.4572 2.29897C9.39272 2.39765 9.36672 2.51671 9.38423 2.63336L9.69434 4.79382C9.7259 5.01376 9.73145 5.23675 9.7108 5.45806L9.60114 6.63997C9.57053 6.97246 9.68784 7.30169 9.92184 7.5394C10.358 7.98128 10.436 8.66487 10.1104 9.19408C9.51056 10.173 9.36148 11.3637 9.70126 12.4608C9.81092 12.8142 9.84038 13.1878 9.78733 13.554L9.43361 15.9946L9.54442 18.6066L10.358 18.9778L11.8177 16.3304C12.6435 14.8407 12.6175 13.0233 11.7494 11.5579H11.7497Z",
    fill: "url(#paint118_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M9.73712 4.73062C9.79142 5.0401 9.82025 5.35357 9.82319 5.66788C9.80432 5.98114 9.7693 6.29314 9.71824 6.60272C9.66666 6.90621 9.6328 7.21243 9.61687 7.51991C9.62945 7.82519 9.67411 8.12825 9.75012 8.42407L9.93641 9.34L10.0968 10.1307L10.3326 9.69929C10.4505 9.48775 10.5684 9.27022 10.6993 9.06226C10.8319 8.85461 10.9798 8.65705 11.1415 8.47136L11.6214 7.91819L11.1721 8.49616C11.0222 8.68721 10.8867 8.88908 10.7665 9.10009C10.6486 9.31047 10.5472 9.53262 10.4375 9.75131L10.1393 10.36C10.204 10.6317 10.2454 10.9085 10.2631 11.1873C10.2752 11.5086 10.2456 11.8299 10.1746 12.1435L9.95885 13.0535L9.89867 13.3041C9.98359 13.154 10.0638 13.0004 10.1593 12.8526C10.257 12.7002 10.3657 12.5552 10.4847 12.4188L10.8384 12.0111L10.5071 12.4377C10.3969 12.5786 10.2972 12.7276 10.2089 12.8833C10.1204 13.0381 10.0473 13.2024 9.96598 13.3631L9.80914 13.6834L9.73722 13.9706C9.66111 14.2694 9.60093 14.5719 9.5568 14.8771C9.51517 15.1821 9.49505 15.4898 9.49662 15.7977C9.49662 16.105 9.51549 16.4194 9.52377 16.7303C9.53551 17.3531 9.55564 17.976 9.56151 18.6001C9.5049 17.9795 9.4637 17.358 9.41411 16.7363C9.39409 16.4243 9.3705 16.117 9.35393 15.8014C9.34198 15.4859 9.35215 15.17 9.38455 14.856C9.39283 14.7744 9.40698 14.694 9.41872 14.6136L9.33506 14.1881C9.29847 14.012 9.27017 13.8336 9.2254 13.661C9.18022 13.4875 9.12224 13.3177 9.05211 13.1528L8.84222 12.6553L9.078 13.141C9.15789 13.3035 9.22572 13.4719 9.28076 13.6444C9.33622 13.8181 9.37396 13.999 9.41988 14.168L9.46118 14.3335C9.48708 14.1963 9.51538 14.0593 9.54725 13.9269L9.75358 13.0157L9.95874 12.1057C9.98726 11.9719 10.0077 11.8365 10.0201 11.7002L9.53897 11.2168C9.36568 11.0454 9.19825 10.8623 9.01782 10.7062C8.83635 10.5448 8.64324 10.3971 8.44006 10.2642L7.82812 9.86123L8.46009 10.23C8.67238 10.353 8.87535 10.4917 9.06731 10.6449C9.26073 10.7985 9.43634 10.9687 9.61917 11.1306L10.0318 11.5029V11.2051C10.013 10.8998 9.96881 10.5965 9.89972 10.2986L9.72401 9.3814L9.5483 8.46421C9.52 8.30942 9.48813 8.16167 9.46223 8.00205C9.43854 7.84242 9.4291 7.68111 9.43392 7.51981C9.45982 7.20539 9.50427 6.89286 9.56717 6.5837C9.6155 6.27527 9.68512 5.97147 9.70273 5.66651C9.71667 5.35767 9.70514 5.04808 9.66855 4.74113L9.59663 3.80859L9.73691 4.73051L9.73712 4.73062Z",
    fill: "url(#paint119_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M13.4857 13.5649V14.0376C13.4859 14.2113 13.4074 14.3757 13.2722 14.4844L13.0695 14.6474C12.9251 14.7636 12.8722 14.96 12.9386 15.1332L13.0566 15.4476C13.2223 15.8826 13.1752 16.3703 12.9292 16.7653C12.8068 16.9611 12.5926 17.08 12.362 17.0798C12.0149 17.0798 11.7335 17.3618 11.7335 17.7098V17.9993C11.7335 18.3022 11.6767 18.6026 11.5661 18.8845C11.4067 19.2911 11.131 19.6413 10.7737 19.8914L10.0521 20.3961H9.17139L9.03583 18.6693C8.95951 17.6989 9.40193 16.7607 10.1984 16.2039C10.5654 15.9474 10.7219 15.4805 10.584 15.0539L10.5309 14.8897C10.427 14.5696 10.4374 14.2231 10.5604 13.9098L10.6417 13.7042C10.7498 13.4295 11.0396 13.2728 11.328 13.333L11.7006 13.411C11.8755 13.4478 12.0474 13.3373 12.0873 13.1628L12.1982 12.6771C12.3149 12.1645 12.7316 11.7749 13.2499 11.6938H13.2616C13.6335 11.6357 13.982 11.8908 14.0399 12.2636C14.0454 12.2984 14.0481 12.3335 14.0481 12.3687C14.0481 12.6141 13.9626 12.8519 13.8064 13.0411L13.5706 13.3271C13.5157 13.3941 13.4857 13.478 13.4857 13.5647V13.5649Z",
    fill: "url(#paint120_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M10.2013 16.2076C10.569 15.9511 10.7261 15.4837 10.5881 15.0565L10.535 14.8922C10.4311 14.5721 10.4415 14.2257 10.5645 13.9124L10.6459 13.7068C10.7539 13.4321 11.0437 13.2754 11.3321 13.3356L11.7047 13.4136C11.8796 13.4504 12.0515 13.3399 12.0915 13.1654L12.2023 12.6797C12.3191 12.167 12.7357 11.7775 13.254 11.6964H13.2657C13.4159 11.6741 13.5555 11.7781 13.5776 11.9285C13.5873 11.9937 13.5732 12.0602 13.5381 12.1159L12.866 13.1689C12.7978 13.2763 12.7423 13.3913 12.7009 13.5117L12.4793 14.1523C12.4167 14.3329 12.2778 14.4765 12.0996 14.5447C11.7693 14.6719 11.5679 15.0083 11.6115 15.3602C11.6948 16.0125 11.4933 16.6689 11.0585 17.1614C10.9178 17.3195 10.8142 17.5073 10.7555 17.711L10.3629 19.0677L9.68732 20.4033H9.17561L9.04005 18.6765C8.96226 17.7052 9.40426 16.7653 10.2014 16.2075L10.2013 16.2076Z",
    fill: "url(#paint121_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M12.8655 13.1278C12.7638 13.2778 12.6747 13.4358 12.599 13.6006C12.5348 13.7682 12.4794 13.939 12.4327 14.1123C12.3878 14.2828 12.3331 14.4505 12.2688 14.6147C12.1902 14.7708 12.0953 14.9181 11.9859 15.0543L11.6722 15.4881L11.401 15.8628L11.3774 15.5803C11.3644 15.4408 11.3574 15.3014 11.3374 15.1607C11.3169 15.0216 11.2861 14.884 11.2454 14.7494L11.1275 14.3475L11.2253 14.7553C11.2582 14.8905 11.2811 15.028 11.2936 15.1666C11.3066 15.3049 11.3054 15.4443 11.3114 15.5849L11.3231 15.9726C11.2244 16.0995 11.1369 16.2348 11.0613 16.3767C10.9792 16.5415 10.9189 16.7164 10.882 16.8968L10.7795 17.4228L10.7512 17.5681C10.7418 17.4701 10.7371 17.3707 10.7229 17.2714C10.708 17.1687 10.6856 17.0672 10.6557 16.9677L10.5672 16.6711L10.6391 16.9725C10.6635 17.072 10.6803 17.1731 10.6899 17.275C10.6993 17.3766 10.6993 17.4795 10.7029 17.5834L10.7087 17.7879L10.6769 17.9499C10.6467 18.1236 10.6074 18.2956 10.5589 18.4652C10.5085 18.6341 10.4462 18.7992 10.3726 18.9592C10.2972 19.1187 10.2158 19.2784 10.1369 19.439C9.98358 19.7605 9.82559 20.0808 9.67578 20.4047C9.85149 20.0938 10.0201 19.7807 10.1934 19.4686C10.277 19.3114 10.3631 19.1566 10.4457 18.9958C10.5265 18.8343 10.5958 18.6672 10.6532 18.4959C10.6685 18.4522 10.6803 18.4061 10.6932 18.3612L10.8371 18.1591C10.8972 18.0751 10.955 17.9901 11.0186 17.9109C11.083 17.8313 11.1532 17.7567 11.2285 17.6875L11.4549 17.4783L11.2191 17.6756C11.1392 17.7417 11.0644 17.8136 10.9951 17.8907C10.9254 17.9675 10.863 18.0515 10.7982 18.1271L10.7368 18.2039C10.7557 18.1259 10.7734 18.0478 10.7876 17.9675L10.8948 17.444L11.0033 16.9205C11.0201 16.8441 11.0413 16.7686 11.067 16.6947L11.4325 16.5564C11.5634 16.508 11.6931 16.4548 11.8252 16.4134C11.9579 16.3723 12.0934 16.3411 12.2308 16.32L12.6447 16.2549L12.2285 16.2975C12.0885 16.3113 11.9498 16.3353 11.8134 16.3696C11.6766 16.4039 11.5446 16.4511 11.4114 16.4878L11.1084 16.5835C11.1297 16.5315 11.1532 16.4795 11.178 16.4288C11.26 16.2742 11.3547 16.1267 11.461 15.9879L11.7699 15.5518L12.0789 15.1157C12.1308 15.0425 12.1814 14.9727 12.2333 14.8947C12.2833 14.8172 12.3263 14.7353 12.3618 14.6501C12.4223 14.4798 12.4727 14.3062 12.5128 14.13C12.56 13.9575 12.5965 13.7825 12.659 13.6194C12.7247 13.4557 12.8035 13.2975 12.8948 13.1466L13.153 12.6738L12.8654 13.1277L12.8655 13.1278Z",
    fill: "url(#paint122_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M5.07345 11.7595L5.01212 12.3397C4.99074 12.5518 5.06559 12.7623 5.21614 12.913L5.44374 13.1387C5.60509 13.2996 5.64461 13.5463 5.54155 13.7498L5.35526 14.1185C5.09662 14.6294 5.0918 15.2322 5.34226 15.7472C5.46701 16.0023 5.71359 16.1755 5.9955 16.2058C6.41967 16.2504 6.72748 16.6312 6.68292 17.0565C6.68292 17.0565 6.68292 17.0566 6.68292 17.0567L6.64518 17.4113C6.60639 17.7817 6.63711 18.1561 6.73597 18.5152C6.87855 19.0332 7.17063 19.4975 7.57551 19.8496L8.39262 20.5587L9.47035 20.677L9.85594 18.5803C10.0735 17.4033 9.65256 16.1989 8.7499 15.4152C8.3338 15.0543 8.20223 14.4631 8.42564 13.9591L8.51171 13.7653C8.67935 13.387 8.71059 12.9622 8.6002 12.5634L8.52712 12.301C8.43025 11.9512 8.09624 11.7223 7.73591 11.7585L7.26425 11.8058C7.04535 11.828 6.8492 11.6702 6.8233 11.4512L6.75023 10.8426C6.67296 10.2007 6.21335 9.67078 5.58999 9.50474H5.57468C5.12713 9.38599 4.66825 9.65344 4.54979 10.1022C4.53878 10.1439 4.53102 10.1863 4.52651 10.2293C4.49527 10.53 4.5695 10.8321 4.7364 11.0838L4.98874 11.4643C5.05007 11.5501 5.07995 11.6544 5.07366 11.7598L5.07345 11.7595Z",
    fill: "url(#paint123_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M8.75338 15.4142C8.33655 15.0528 8.20445 14.4608 8.42796 13.9557L8.51404 13.7619C8.68167 13.3836 8.71291 12.9588 8.60252 12.56L8.52945 12.2976C8.43258 11.9478 8.09856 11.7189 7.73824 11.7551L7.26657 11.8024C7.04767 11.8246 6.85152 11.6668 6.82562 11.4478L6.75255 10.8392C6.67529 10.1973 6.21568 9.66737 5.59231 9.50134H5.57103C5.39081 9.45405 5.20661 9.56218 5.15944 9.74282C5.13868 9.82227 5.14749 9.90665 5.18428 9.98L5.87171 11.3545C5.94142 11.4944 5.99447 11.6419 6.0297 11.7942L6.2183 12.6062C6.27166 12.8352 6.42305 13.029 6.6322 13.1357C7.02251 13.333 7.22652 13.7732 7.12504 14.1994C6.94178 14.9873 7.1069 15.8163 7.57783 16.4734C7.72943 16.6844 7.83217 16.9267 7.87851 17.1825L8.18506 18.8927L8.83945 20.6134L9.46554 20.6796L9.8546 18.5794C10.0732 17.4033 9.65425 16.199 8.75328 15.4143L8.75338 15.4142Z",
    fill: "url(#paint124_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M5.88779 11.304C5.99273 11.4988 6.08142 11.702 6.15313 11.9115C6.21016 12.1248 6.25629 12.3411 6.2911 12.5591C6.32402 12.7732 6.3692 12.985 6.42665 13.1938C6.50287 13.395 6.60016 13.5875 6.71674 13.7682L7.04457 14.3391L7.32753 14.8319L7.39242 14.4891C7.4266 14.3201 7.4526 14.1499 7.49621 13.9809C7.53909 13.8132 7.59423 13.6489 7.66133 13.4892L7.85947 13.0165L7.68733 13.5034C7.62967 13.6645 7.58396 13.8296 7.55052 13.9974C7.51749 14.1641 7.49977 14.3355 7.47503 14.5068L7.4114 14.9796C7.5155 15.1477 7.60503 15.3245 7.67905 15.5078C7.75851 15.7197 7.80999 15.941 7.83232 16.1662L7.89008 16.8221L7.90539 17.003C7.92898 16.8848 7.94785 16.7667 7.97846 16.6484C8.00887 16.5247 8.04818 16.4035 8.09641 16.2856L8.24265 15.931L8.11528 16.2856C8.07303 16.4043 8.03948 16.5259 8.01505 16.6496C7.99031 16.7678 7.97731 16.899 7.95959 17.0242L7.92542 17.2736L7.94313 17.4757C7.95844 17.692 7.98517 17.9075 8.02333 18.121C8.06317 18.3342 8.1179 18.5443 8.1872 18.7497C8.25796 18.9542 8.33816 19.161 8.41239 19.3667C8.55864 19.7803 8.71065 20.194 8.85333 20.6076C8.67763 20.2058 8.51135 19.7992 8.34047 19.3951C8.25796 19.1918 8.17304 18.9909 8.09284 18.784C8.01463 18.576 7.95121 18.3627 7.90298 18.1458C7.88998 18.0902 7.8817 18.0276 7.87111 17.9756L7.72014 17.7096C7.65651 17.5997 7.6022 17.4874 7.52913 17.3822C7.46035 17.2766 7.38393 17.1763 7.30037 17.082L7.04918 16.796L7.31453 17.0678C7.40416 17.1588 7.48688 17.2565 7.56215 17.3598C7.63764 17.4638 7.70243 17.5725 7.77204 17.6789L7.83693 17.7805C7.82393 17.6825 7.81219 17.5855 7.80391 17.4897L7.73901 16.835L7.67412 16.1813C7.66332 16.0855 7.64676 15.9904 7.62464 15.8965L7.19543 15.6803C7.041 15.6046 6.89004 15.5219 6.73435 15.4557C6.5771 15.3887 6.41512 15.3333 6.24979 15.2902L5.75223 15.1578L6.25692 15.263C6.42603 15.2979 6.5924 15.3454 6.75448 15.4048C6.91834 15.4639 7.07287 15.5384 7.22615 15.6058L7.57987 15.763C7.55985 15.6956 7.53856 15.6294 7.51382 15.5645C7.43331 15.3645 7.33633 15.1716 7.22374 14.9878L6.90188 14.4134L6.58003 13.839C6.52698 13.7421 6.47278 13.6499 6.41963 13.5494C6.36836 13.4483 6.32612 13.3426 6.29351 13.2339C6.2413 13.0181 6.20199 12.7996 6.17557 12.5791C6.13898 12.3617 6.1178 12.143 6.05763 11.9362C5.99818 11.7265 5.92176 11.5221 5.82887 11.3251L5.57422 10.7188L5.88779 11.3038V11.304Z",
    fill: "url(#paint125_linear_2881_52824)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M8.07649 24.0293H8.51041C8.53107 24.0293 8.54784 24.0461 8.54784 24.0668V24.5018C8.54784 24.5225 8.53107 24.5393 8.51041 24.5393H8.07649C8.05584 24.5393 8.03906 24.5225 8.03906 24.5018V24.0668C8.03906 24.0461 8.05584 24.0293 8.07649 24.0293Z",
    fill: "url(#paint126_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M12.7828 25.7626H14.1445V24.9226H16.898V20.9102H14.3914C14.1394 20.9102 13.935 21.115 13.935 21.3677V23.6177H10.7775V23.7302C10.7651 24.8403 11.6528 25.7502 12.7602 25.7626C12.7677 25.7626 12.7753 25.7627 12.7827 25.7627L12.7828 25.7626Z",
    fill: "url(#paint127_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M12.7828 25.7626H14.1445V24.9226H16.898V20.9102H14.3914C14.1394 20.9102 13.935 21.115 13.935 21.3677V23.6177H10.7775V23.7302C10.7651 24.8403 11.6528 25.7502 12.7602 25.7626C12.7677 25.7626 12.7753 25.7627 12.7827 25.7627L12.7828 25.7626Z",
    fill: "url(#paint128_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M12.7828 25.7626H14.1445V24.9226H16.898V20.9102H14.3914C14.1394 20.9102 13.935 21.115 13.935 21.3677V23.6177H10.7775V23.7302C10.7651 24.8403 11.6528 25.7502 12.7602 25.7626C12.7677 25.7626 12.7753 25.7627 12.7827 25.7627L12.7828 25.7626Z",
    fill: "url(#paint129_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M5.51133 15.9004H18.1893V30.5599H7.11476C6.22511 30.5599 5.50391 29.8369 5.50391 28.9452V15.9004H5.51133Z",
    fill: "url(#paint130_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M11.5407 23.3325C12.6828 24.4762 13.3241 26.0284 13.3233 27.6468V30.5704H18.2015V15.9004H16.374L6.05078 21.5455H7.23678C8.85116 21.5447 10.3996 22.1876 11.5407 23.3325Z",
    fill: "url(#paint131_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M29.2686 30.5599H18.1875V15.9004H30.8729V28.9452C30.8729 29.834 30.1558 30.5558 29.2685 30.5599H29.2686Z",
    fill: "url(#paint132_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M11.9088 21.5435H0.28203C0.175027 21.5403 0.0906998 21.4509 0.0938346 21.3437C0.0951931 21.2955 0.11442 21.2494 0.147859 21.2146L5.40563 15.9004H18.0839L12.9156 21.1324C12.6479 21.3981 12.2856 21.5461 11.9088 21.5435Z",
    fill: "url(#paint133_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M27.9424 1.82193C26.9331 1.73208 25.9507 2.1789 25.3535 2.99941V3.19445C25.0993 4.024 24.9067 4.87131 24.7773 5.72944C24.8323 5.80205 24.9009 5.86321 24.9794 5.90945C25.1002 5.99121 25.1774 6.12372 25.1888 6.26948C25.1432 6.95222 25.3879 7.62246 25.8622 8.11447C27.0669 8.86447 27.0669 8.5945 27.0669 8.86447C27.0669 9.13443 29.2667 8.66943 29.2667 8.66943C29.2667 8.66943 32.948 2.6169 27.9423 1.82193H27.9424Z",
    fill: "#FFC3AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M26.2878 4.76321C27.3802 5.5132 27.3952 7.18575 27.036 7.5607C26.7672 7.84664 26.4824 8.11713 26.183 8.3707C27.0061 8.85073 27.0061 8.65569 27.0061 8.91074C27.0061 9.16578 29.2059 8.7157 29.2059 8.7157C29.5386 8.14361 29.8214 7.54388 30.0514 6.92325L29.9093 3.67578L26.2206 2.17578C25.8846 2.39678 25.5906 2.6762 25.3526 3.00081V3.19585L25.2254 3.66832C25.5322 3.88584 25.5397 3.93082 25.3826 4.32836C25.2518 4.74955 25.1567 5.18113 25.0983 5.6184C25.0983 5.71592 24.8438 5.6184 24.7691 5.66337C24.7645 5.68565 24.7645 5.70866 24.7691 5.73084C24.824 5.80345 24.8927 5.86461 24.9711 5.91085C25.092 5.99261 25.1691 6.12512 25.1806 6.27087C25.1806 6.27087 25.188 3.99083 26.288 4.76342L26.2878 4.76321Z",
    fill: "url(#paint134_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M25.7017 0.224136C25.2317 0.293493 24.8471 0.634917 24.7216 1.09414C24.3894 2.02342 24.8173 3.05336 25.7093 3.47161C27.2057 4.28161 27.6172 5.03907 27.7369 5.36158C27.7738 5.46288 27.8688 5.53139 27.9764 5.53413C28.0703 5.53413 28.1566 5.48221 28.2008 5.39909C28.343 5.12156 28.6946 4.5066 29.0015 4.43157C29.7497 4.24409 30.3782 4.82154 29.2109 6.43408C29.0089 6.71161 28.1634 7.44658 29.0688 7.77655C29.9742 8.10652 31.5529 8.27151 31.6876 8.36903C31.8223 8.46655 34.2615 3.4715 32.7127 1.304C31.4855 -0.435803 27.3253 -0.000852927 25.7017 0.224136Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M33.1803 2.4595C33.1803 3.15696 32.2524 4.03453 30.9356 2.97705C29.5738 1.82205 28.0848 2.18208 27.7855 3.43459C27.5311 4.37207 26.723 4.0421 26.2891 3.81711C26.9195 4.17083 27.4262 4.71013 27.7406 5.36208C27.7775 5.46338 27.8725 5.5319 27.9801 5.53463C28.074 5.53463 28.1603 5.48272 28.2046 5.3996C28.3467 5.12206 28.6983 4.5071 29.0052 4.43207C29.7534 4.2446 30.3819 4.82204 29.2147 6.43459C29.0126 6.71212 28.1671 7.44709 29.0725 7.77706C29.9779 8.10703 31.5566 8.27201 31.6914 8.36953C31.8261 8.46705 33.5844 4.87459 33.1804 2.4595H33.1803Z",
    fill: "#0C0C0C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M13.2003 29.3622C13.2003 29.3622 11.7038 28.5297 10.7087 29.3622C9.71357 30.1947 8.65104 29.7222 8.32929 30.4122C8.00754 31.1022 13.8138 31.1622 14.4274 30.5922",
    fill: "#FFC3AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M19.0089 29.077C19.0089 29.077 17.5124 28.2445 16.5173 29.077C15.5222 29.9095 14.4596 29.4371 14.1379 30.127C13.8161 30.817 19.6224 30.877 20.236 30.3071",
    fill: "#FFC3AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M29.0415 13.8006C30.7651 12.1147 33.2557 11.4798 35.5735 12.1356C38.4168 12.8856 39.3146 11.7006 39.5541 10.9356C39.6369 10.6622 39.9253 10.5078 40.1981 10.5908C40.2344 10.6018 40.2693 10.6169 40.3023 10.6356C40.744 10.8473 41.1524 11.1228 41.5144 11.453C41.6551 11.6016 41.6934 11.8202 41.6117 12.008C41.1852 12.9904 39.2922 16.238 33.5458 13.988C28.0164 11.828 26.6172 16.688 26.6172 16.688",
    fill: "url(#paint135_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M25.4877 11.6544C25.4877 11.6544 24.5225 8.51935 27.7324 7.46187C30.9423 6.40439 35.2671 9.74938 33.1346 12.5168",
    fill: "#FFBD66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M29.0874 7.25977C29.9479 7.38723 30.7859 8.51975 29.2296 8.71479C28.1171 8.89469 27.0889 9.41928 26.2891 10.2148L29.282 12.0898L33.1803 12.5323C34.9536 10.1174 31.9756 7.31987 29.0875 7.25987L29.0874 7.25977Z",
    fill: "url(#paint136_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M18.6098 29.1966C18.6098 29.1966 18.5649 30.4042 19.4253 30.5916C20.2858 30.7791 36.4999 30.3741 37.2182 22.4992C37.9365 14.6242 31.1875 8.75921 28.6135 9.11924",
    fill: "#0385A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M18.6098 29.1966C18.6098 29.1966 18.5649 30.4042 19.4253 30.5916C20.2858 30.7791 36.4999 30.3741 37.2182 22.4992C37.9365 14.6242 31.1875 8.75921 28.6135 9.11924",
    fill: "url(#paint137_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M33.0678 36.3895C33.7166 34.4298 34.05 32.3792 34.0555 30.3145H23.4231C23.4231 30.3145 23.281 34.8144 26.027 41.3994C28.3695 40.8257 30.5948 39.8486 32.6039 38.512C32.686 37.7905 32.8414 37.0793 33.0678 36.3895Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M23.3833 29.7066C20.2131 33.1051 17.6967 37.0614 15.9609 41.3766C17.6251 41.7921 19.3339 42.0011 21.0489 41.9991C21.5877 41.9991 22.1189 41.9991 22.6427 41.9316C25.0145 39.3591 27.4163 37.4841 29.1597 36.8617C35.1455 34.7242 34.0755 29.6992 34.0755 29.6992L23.3833 29.7067V29.7066Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M21.5884 40.4998C21.1694 40.9998 20.7753 41.4998 20.4062 41.9998H21.0497C21.5885 41.9998 22.1197 41.9998 22.6435 41.9323C25.0153 39.3598 27.4172 37.4848 29.1605 36.8623C33.1785 35.4224 34.0165 32.6698 34.1288 31.0273L22.202 31.7773C22.202 31.7773 28.345 32.4374 21.5885 40.4998H21.5884Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M28.294 19.417C27.6805 24.817 25.1515 27.667 22.2109 29.7295C24.8298 26.302 24.4556 16.4395 26.7003 11.632C27.7927 10.642 27.5608 13.0421 27.5608 13.0421L28.294 19.4171V19.417Z",
    fill: "url(#paint138_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M22.36 30.5621C22.36 30.5621 21.7015 30.3746 21.6118 31.237C21.4172 32.6696 33.2318 32.7896 34.0997 31.7546C34.0997 31.7546 35.3044 31.0796 34.2643 30.4121C34.2343 30.4121 24.7169 31.0946 22.36 30.5621Z",
    fill: "#0385A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M22.36 30.5621C22.36 30.5621 21.7015 30.3746 21.6118 31.237C21.4172 32.6696 33.2318 32.7896 34.0997 31.7546C34.0997 31.7546 35.3044 31.0796 34.2643 30.4121C34.2343 30.4121 24.7169 31.0946 22.36 30.5621Z",
    fill: "url(#paint139_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    d: "M34.3442 30.5931C32.1668 32.0931 21.976 31.0806 22.3127 30.8556C22.0658 30.8556 21.8788 30.1582 22.208 29.7306C24.8268 26.3031 24.4526 16.4406 26.6973 11.6331C27.6326 9.63059 27.857 9.01563 28.8821 9.12061C35.6162 9.81806 38.8187 27.5181 34.3442 30.5931Z",
    fill: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M28.8551 9.12061C27.83 9.01563 27.6056 9.63059 26.6703 11.6331C26.5207 11.9556 26.3786 12.3081 26.2513 12.6756L24.4405 22.1556C24.2415 23.5912 23.9694 25.0155 23.625 26.4231C23.625 26.4231 27.1267 22.2607 29.7231 21.9681C32.3194 21.6756 32.8806 26.3031 28.2939 27.6531C23.7073 29.0032 23.6999 31.2006 25.7724 31.2907H26.1016C29.1394 31.4632 33.0901 31.4406 34.3321 30.5407C38.8214 27.5182 35.6191 9.81817 28.855 9.12071L28.8551 9.12061Z",
    fill: "url(#paint140_linear_2881_52824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    d: "M28.6123 9.11934C28.6123 9.11934 24.8711 8.97684 23.3747 16.3718C22.1775 22.4844 19.4015 27.1644 13.2811 28.8968C12.8649 29 12.5625 29.3606 12.5329 29.7893C12.502 30.331 12.915 30.7953 13.4555 30.8263C13.5021 30.8289 13.5489 30.8283 13.5953 30.8243C14.8893 30.704 16.1678 30.4527 17.4113 30.0743C23.7757 28.1064 28.1892 22.3022 28.3953 15.6293L28.6123 9.11934Z",
    fill: "#EDD7AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2881_52824",
    x1: 21.048,
    y1: 47.625,
    x2: 21.048,
    y2: -8.42232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#44E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9844FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4447FF",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2881_52824",
    x1: 35.9082,
    y1: 33.7957,
    x2: 35.9082,
    y2: -11.4292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2881_52824",
    x1: -50.9976,
    y1: 22.3208,
    x2: -51.0081,
    y2: -11.4368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2881_52824",
    x1: 28.4633,
    y1: 33.7953,
    x2: 28.4633,
    y2: -11.4297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2881_52824",
    x1: 28.4633,
    y1: 22.3203,
    x2: 28.4633,
    y2: -11.4372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2881_52824",
    x1: 31.6085,
    y1: 33.7951,
    x2: 31.6085,
    y2: -11.4299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2881_52824",
    x1: 31.6085,
    y1: 22.3201,
    x2: 31.6085,
    y2: -11.4374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2881_52824",
    x1: 31.6085,
    y1: 30.6751,
    x2: 31.6085,
    y2: 11.3326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2881_52824",
    x1: 23.4055,
    y1: 33.7946,
    x2: 23.4055,
    y2: -11.4303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2881_52824",
    x1: 25.2068,
    y1: 27.3065,
    x2: 25.2068,
    y2: -14.1454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2881_52824",
    x1: 23.4054,
    y1: 33.7956,
    x2: 23.4054,
    y2: -11.4294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2881_52824",
    x1: 23.4055,
    y1: 27.3306,
    x2: 23.4055,
    y2: -14.2194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2881_52824",
    x1: 14.6587,
    y1: 33.796,
    x2: 14.6587,
    y2: -11.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2881_52824",
    x1: 14.6587,
    y1: 27.331,
    x2: 14.6587,
    y2: -14.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2881_52824",
    x1: 19.304,
    y1: 33.7949,
    x2: 19.304,
    y2: -11.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2881_52824",
    x1: 19.304,
    y1: 27.3299,
    x2: 19.304,
    y2: -14.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2881_52824",
    x1: 19.304,
    y1: 31.4548,
    x2: 19.304,
    y2: 8.30233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2881_52824",
    x1: 4.77397,
    y1: 33.7952,
    x2: 4.77397,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2881_52824",
    x1: 4.77397,
    y1: 31.4552,
    x2: 4.77397,
    y2: 8.30272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2881_52824",
    x1: 4.77397,
    y1: 28.1928,
    x2: 4.77397,
    y2: 7.14026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2881_52824",
    x1: 5.65668,
    y1: 33.7952,
    x2: 5.65668,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2881_52824",
    x1: 5.65668,
    y1: 31.4552,
    x2: 5.65668,
    y2: 8.30272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2881_52824",
    x1: 5.65668,
    y1: 28.1928,
    x2: 5.65668,
    y2: 7.14026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7952,
    x2: 6.53569,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4552,
    x2: 6.53569,
    y2: 8.30272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2881_52824",
    x1: 6.53569,
    y1: 28.1928,
    x2: 6.53569,
    y2: 7.14026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7952,
    x2: 7.41069,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4552,
    x2: 7.41069,
    y2: 8.30272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2881_52824",
    x1: 7.41069,
    y1: 28.1928,
    x2: 7.41069,
    y2: 7.14026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7952,
    x2: 8.2935,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4552,
    x2: 8.2935,
    y2: 8.30272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2881_52824",
    x1: 8.2935,
    y1: 28.1928,
    x2: 8.2935,
    y2: 7.14026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2881_52824",
    x1: 4.77397,
    y1: 33.7949,
    x2: 4.77397,
    y2: -11.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2881_52824",
    x1: 4.77397,
    y1: 31.4548,
    x2: 4.77397,
    y2: 8.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2881_52824",
    x1: 4.77397,
    y1: 28.1923,
    x2: 4.77397,
    y2: 7.13984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2881_52824",
    x1: 5.65668,
    y1: 33.7949,
    x2: 5.65668,
    y2: -11.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2881_52824",
    x1: 5.65668,
    y1: 31.4548,
    x2: 5.65668,
    y2: 8.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2881_52824",
    x1: 5.65668,
    y1: 28.1923,
    x2: 5.65668,
    y2: 7.13984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7949,
    x2: 6.53569,
    y2: -11.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4548,
    x2: 6.53569,
    y2: 8.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2881_52824",
    x1: 6.53569,
    y1: 28.1923,
    x2: 6.53569,
    y2: 7.13984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7949,
    x2: 7.41069,
    y2: -11.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4548,
    x2: 7.41069,
    y2: 8.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2881_52824",
    x1: 7.41069,
    y1: 28.1923,
    x2: 7.41069,
    y2: 7.13984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7949,
    x2: 8.2935,
    y2: -11.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4548,
    x2: 8.2935,
    y2: 8.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2881_52824",
    x1: 8.2935,
    y1: 28.1923,
    x2: 8.2935,
    y2: 7.13984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2881_52824",
    x1: 4.77397,
    y1: 33.7946,
    x2: 4.77397,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2881_52824",
    x1: 4.77397,
    y1: 31.4545,
    x2: 4.77397,
    y2: 8.30208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2881_52824",
    x1: 4.77397,
    y1: 28.1921,
    x2: 4.77397,
    y2: 7.13951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2881_52824",
    x1: 5.65668,
    y1: 33.7946,
    x2: 5.65668,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2881_52824",
    x1: 5.65668,
    y1: 31.4545,
    x2: 5.65668,
    y2: 8.30208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2881_52824",
    x1: 5.65668,
    y1: 28.1921,
    x2: 5.65668,
    y2: 7.13951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7946,
    x2: 6.53569,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4545,
    x2: 6.53569,
    y2: 8.30208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2881_52824",
    x1: 6.53569,
    y1: 28.1921,
    x2: 6.53569,
    y2: 7.13951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7946,
    x2: 7.41069,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4545,
    x2: 7.41069,
    y2: 8.30208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2881_52824",
    x1: 7.41069,
    y1: 28.1921,
    x2: 7.41069,
    y2: 7.13951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7946,
    x2: 8.2935,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4545,
    x2: 8.2935,
    y2: 8.30208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2881_52824",
    x1: 8.2935,
    y1: 28.1921,
    x2: 8.2935,
    y2: 7.13951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2881_52824",
    x1: 4.77397,
    y1: 33.7958,
    x2: 4.77397,
    y2: -11.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2881_52824",
    x1: 4.77397,
    y1: 31.4558,
    x2: 4.77397,
    y2: 8.30338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2881_52824",
    x1: 4.77397,
    y1: 28.1934,
    x2: 4.77397,
    y2: 7.14093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2881_52824",
    x1: 5.65668,
    y1: 33.7958,
    x2: 5.65668,
    y2: -11.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2881_52824",
    x1: 5.65668,
    y1: 31.4558,
    x2: 5.65668,
    y2: 8.30338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2881_52824",
    x1: 5.65668,
    y1: 28.1934,
    x2: 5.65668,
    y2: 7.14093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7958,
    x2: 6.53569,
    y2: -11.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4558,
    x2: 6.53569,
    y2: 8.30338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2881_52824",
    x1: 6.53569,
    y1: 28.1934,
    x2: 6.53569,
    y2: 7.14093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7958,
    x2: 7.41069,
    y2: -11.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4558,
    x2: 7.41069,
    y2: 8.30338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2881_52824",
    x1: 7.41069,
    y1: 28.1934,
    x2: 7.41069,
    y2: 7.14093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7958,
    x2: 8.2935,
    y2: -11.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4558,
    x2: 8.2935,
    y2: 8.30338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2881_52824",
    x1: 8.2935,
    y1: 28.1934,
    x2: 8.2935,
    y2: 7.14093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7955,
    x2: 6.53569,
    y2: -11.4294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4554,
    x2: 6.53569,
    y2: 8.30306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2881_52824",
    x1: 6.53569,
    y1: 28.193,
    x2: 6.53569,
    y2: 7.1405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7955,
    x2: 7.41069,
    y2: -11.4294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4554,
    x2: 7.41069,
    y2: 8.30306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2881_52824",
    x1: 7.41069,
    y1: 28.193,
    x2: 7.41069,
    y2: 7.1405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7955,
    x2: 8.2935,
    y2: -11.4294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4554,
    x2: 8.2935,
    y2: 8.30306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2881_52824",
    x1: 8.2935,
    y1: 28.193,
    x2: 8.2935,
    y2: 7.1405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7952,
    x2: 6.53569,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4552,
    x2: 6.53569,
    y2: 8.30271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2881_52824",
    x1: 6.53569,
    y1: 28.1926,
    x2: 6.53569,
    y2: 7.14014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7952,
    x2: 7.41069,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4552,
    x2: 7.41069,
    y2: 8.30271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2881_52824",
    x1: 7.41069,
    y1: 28.1926,
    x2: 7.41069,
    y2: 7.14014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7952,
    x2: 8.2935,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4552,
    x2: 8.2935,
    y2: 8.30271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2881_52824",
    x1: 8.2935,
    y1: 28.1926,
    x2: 8.2935,
    y2: 7.14014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7946,
    x2: 6.53569,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4546,
    x2: 6.53569,
    y2: 8.30214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2881_52824",
    x1: 6.53569,
    y1: 28.1921,
    x2: 6.53569,
    y2: 7.13957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7946,
    x2: 7.41069,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4546,
    x2: 7.41069,
    y2: 8.30214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2881_52824",
    x1: 7.41069,
    y1: 28.1921,
    x2: 7.41069,
    y2: 7.13957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7946,
    x2: 8.2935,
    y2: -11.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4546,
    x2: 8.2935,
    y2: 8.30214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2881_52824",
    x1: 8.2935,
    y1: 28.1921,
    x2: 8.2935,
    y2: 7.13957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2881_52824",
    x1: 6.53569,
    y1: 33.7943,
    x2: 6.53569,
    y2: -11.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2881_52824",
    x1: 6.53569,
    y1: 26.0768,
    x2: 6.53569,
    y2: 8.93181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2881_52824",
    x1: 6.53569,
    y1: 31.4543,
    x2: 6.53569,
    y2: 8.30182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2881_52824",
    x1: 6.53569,
    y1: 28.1918,
    x2: 6.53569,
    y2: 7.13925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2881_52824",
    x1: 7.41069,
    y1: 33.7943,
    x2: 7.41069,
    y2: -11.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2881_52824",
    x1: 7.41069,
    y1: 26.0768,
    x2: 7.41069,
    y2: 8.93181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2881_52824",
    x1: 7.41069,
    y1: 31.4543,
    x2: 7.41069,
    y2: 8.30182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2881_52824",
    x1: 7.41069,
    y1: 28.1918,
    x2: 7.41069,
    y2: 7.13925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2881_52824",
    x1: 8.2935,
    y1: 33.7943,
    x2: 8.2935,
    y2: -11.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2881_52824",
    x1: 8.2935,
    y1: 26.0768,
    x2: 8.2935,
    y2: 8.93181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2881_52824",
    x1: 8.2935,
    y1: 31.4543,
    x2: 8.2935,
    y2: 8.30182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2881_52824",
    x1: 18.543,
    y1: 16.1737,
    x2: 18.543,
    y2: 7.38758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2881_52824",
    x1: 19.3206,
    y1: 20.0372,
    x2: 12.2873,
    y2: 8.54213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2881_52824",
    x1: 9.18552,
    y1: 0.88483,
    x2: 9.78885,
    y2: 24.2383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ADE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#49B243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2881_52824",
    x1: 10.6805,
    y1: 1.00649,
    x2: 11.6875,
    y2: 24.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ADE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#49B243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2881_52824",
    x1: 9.25207,
    y1: 2.867,
    x2: 9.95801,
    y2: 23.1795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32914B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#33872E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2881_52824",
    x1: 10.9121,
    y1: 11.1311,
    x2: 11.0972,
    y2: 23.1045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ADE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#49B243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2881_52824",
    x1: 10.739,
    y1: 11.1389,
    x2: 10.9433,
    y2: 23.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ADE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#49B243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2881_52824",
    x1: 10.9811,
    y1: 12.1817,
    x2: 11.1916,
    y2: 22.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32914B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#33872E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2881_52824",
    x1: 6.54393,
    y1: 8.76357,
    x2: 6.82889,
    y2: 24.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ADE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#49B243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2881_52824",
    x1: 6.93648,
    y1: 8.77794,
    x2: 7.25845,
    y2: 24.1557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ADE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#49B243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2881_52824",
    x1: 6.80516,
    y1: 10.0892,
    x2: 7.17034,
    y2: 23.6759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32914B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#33872E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2881_52824",
    x1: 8.2935,
    y1: 28.1918,
    x2: 8.2935,
    y2: 7.13925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2881_52824",
    x1: 13.8377,
    y1: 33.7952,
    x2: 13.8377,
    y2: -11.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2881_52824",
    x1: 13.8377,
    y1: 31.4552,
    x2: 13.8377,
    y2: 8.30269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2881_52824",
    x1: 13.8377,
    y1: 26.5202,
    x2: 13.8377,
    y2: 13.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2881_52824",
    x1: 11.8466,
    y1: 20.468,
    x2: 11.8466,
    y2: 6.75792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2881_52824",
    x1: 12.1262,
    y1: 33.8005,
    x2: 12.1262,
    y2: 16.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2881_52824",
    x1: 24.5302,
    y1: 26.8819,
    x2: 24.5302,
    y2: 6.80275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2881_52824",
    x1: 9.08877,
    y1: 12.0585,
    x2: 9.08877,
    y2: -13.8252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2881_52824",
    x1: 24.1739,
    y1: 12.6705,
    x2: 32.0235,
    y2: -4.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AC93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2881_52824",
    x1: 30.7218,
    y1: 19.1894,
    x2: 38.0601,
    y2: 8.65597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2881_52824",
    x1: 26.2816,
    y1: 9.89606,
    x2: 33.689,
    y2: 9.89606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2881_52824",
    x1: 26.0502,
    y1: 18.7506,
    x2: 32.4899,
    y2: 37.8964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CC98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2881_52824",
    x1: 22.2109,
    y1: 20.5611,
    x2: 28.294,
    y2: 20.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0385A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00758C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2881_52824",
    x1: 26.2015,
    y1: 36.269,
    x2: 32.0932,
    y2: 20.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDC290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2881_52824",
    x1: 25.0541,
    y1: 20.2422,
    x2: 37.8435,
    y2: 20.2422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4CC9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2881_52824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductHostingShip);
export default __webpack_public_path__ + "static/media/icon_product_hosting_ship.6e0ab2db9e29a9a82f71963d1366a49c.svg";
export { ForwardRef as ReactComponent };